import React from 'react';
import { Link } from 'react-router-dom';

const DairyEquipment = () => {
  return (
    <div>
      <div className="bg-gray-100 py-4">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-600">
            <Link to="/" className="hover:text-accent">Home</Link> / 
            <Link to="/services" className="hover:text-accent"> Services</Link> / 
            <span className="text-gray-900"> Dairy Equipment</span>
          </div>
        </div>
      </div>

      <section className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">Dairy Equipment</h1>
          <p className="text-xl text-gray-300">Complete Range of Dairy Processing Equipment</p>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-8 section-title">Our Dairy Equipment Portfolio</h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Road Milk Tanker</h3>
              <p className="text-gray-700">Specialized tankers for safe milk transportation from collection centers to processing plants</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Weigh Bowl</h3>
              <p className="text-gray-700">Precision weighing equipment for accurate milk measurement and batching</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Dump Tank</h3>
              <p className="text-gray-700">Primary receiving tanks for raw milk collection with cooling facility</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Milk Silo/Milk Storage Tank</h3>
              <p className="text-gray-700">Large capacity storage tanks with temperature control for bulk milk storage</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Milk/Cream Pasteuriser</h3>
              <p className="text-gray-700">High temperature short time (HTST) pasteurization systems for milk safety</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Butter Churn</h3>
              <p className="text-gray-700">Traditional and modern churning equipment for butter production from cream</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Butter Melting System</h3>
              <p className="text-gray-700">Controlled melting systems for butter oil and ghee production</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Ghee Boiler</h3>
              <p className="text-gray-700">Specialized boilers for traditional ghee making with temperature control</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Khoa Pan</h3>
              <p className="text-gray-700">Traditional open pan and modern continuous systems for khoa production</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Cheese Kettle</h3>
              <p className="text-gray-700">Jacketed kettles for cheese making with precise temperature control</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Bottle Sterilizer</h3>
              <p className="text-gray-700">UV and steam sterilization systems for bottles and packaging materials</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Triple Concentric Tubular Heater</h3>
              <p className="text-gray-700">Efficient heat exchange system for evaporators</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">Disc Atomizer</h3>
              <p className="text-gray-700">High-speed atomization for spray drying applications</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-accent">CIP Spray Nozzle</h3>
              <p className="text-gray-700">Rotary and turbine type nozzles for automated cleaning systems</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-8 text-center section-title inline-block">Equipment Features</h2>
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="text-center">
              <div className="text-5xl mb-4 text-accent">🏆</div>
              <h3 className="font-bold text-lg mb-2">Hygiene Standards</h3>
              <p className="text-gray-600">Designed as per dairy hygiene requirements</p>
            </div>
            <div className="text-center">
              <div className="text-5xl mb-4 text-green">⚙️</div>
              <h3 className="font-bold text-lg mb-2">Easy Maintenance</h3>
              <p className="text-gray-600">Simple CIP systems and accessible design</p>
            </div>
            <div className="text-center">
              <div className="text-5xl mb-4 text-accent">💪</div>
              <h3 className="font-bold text-lg mb-2">Durable Construction</h3>
              <p className="text-gray-600">Food-grade stainless steel construction</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Need Dairy Processing Equipment?</h2>
          <p className="text-lg mb-6 text-gray-300">
            Get customized solutions for your dairy plant
          </p>
          <Link to="/contact" className="btn-primary px-8 py-3 rounded-lg font-semibold inline-block">
            Request a Quote
          </Link>
        </div>
      </section>
    </div>
  );
};

export default DairyEquipment;